import { gql } from '@apollo/client/core'

export const GET_LOCATION_BLOCKS = gql`
  query GetLocationBlocks($organization: String!) {
    itemLocationBlocks(organization: $organization) {
      item
      location
    }
    variationLocationBlocks(organization: $organization) {
      location
      item
      variation
    }
  }
`

export const GET_CUSTOMER_DISCOUNT = gql`
  query GetCustomerDiscount($organization: String!, $ssn: String!) {
    customerDiscount(organization: $organization, ssn: $ssn)
  }
` 